import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AppHeader from "../layout/appHeader";

// Icons
import { IoClose } from "react-icons/io5";
import { FaWhatsapp } from "react-icons/fa6";
import { TfiEmail } from "react-icons/tfi";
import { MdForum } from "react-icons/md";
import { TbBrandYoutube } from "react-icons/tb";
import { LuInstagram } from "react-icons/lu";
import { BsTelephoneFill } from "react-icons/bs";

const LoginNav = ({ bgcolor }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(0);

  const links = [
    { name: t("nav.li1"), onClick: () => setIsOpen(3), current: isOpen === 3 },
    { name: t("nav.li2"), onClick: () => setIsOpen(2), current: isOpen === 2 },
    { name: t("nav.li3"), onClick: () => setIsOpen(1), current: isOpen === 1 },
  ];

  return (
    <>
      <InfoBox isOpen={isOpen} setIsOpen={setIsOpen} />
      <AppHeader
        breakpoint="sm"
        links={links}
        bg={bgcolor ? "" : "bg-[--nav-bg-1]"}
        className={bgcolor || "relative z-40"}
      />
    </>
  );
};

const Modal = ({ open, onClose, title, children, maxWidth }) => {
  const { t } = useTranslation();
  return (
    <div
      className={`fixed inset-0 flex justify-center items-center transition-colors px-[2%] z-[60] ${
        open ? "visible bg-black/20" : "invisible"
      }`}
      aria-hidden={!open}
    >
      <div
        className={`bg-[--btn-txt] w-full ${maxWidth} rounded-xl shadow px-6 py-2 pb-6 transition-all max-h-[85dvh] overflow-y-auto border border-solid border-[--gr-3] ${
          open ? "scale-100 opacity-100" : "scale-125 opacity-0"
        }`}
        role="dialog"
        aria-modal="true"
      >
        <span className="flex justify-end text-2xl text-[--gr-6]">
          <button
            type="button"
            onClick={onClose}
            aria-label={t("common.close")}
            className="rounded-full p-1 text-4xl cursor-pointer bg-transparent flex items-center hover:bg-[--gr-0] hover:text-[--gr-6]"
          >
            <IoClose aria-hidden="true" />
          </button>
        </span>
        <div className="text-[--gr-5] font-bold text-xl text-center mb-6">
          {title}
        </div>
        {children}
      </div>
    </div>
  );
};

const InfoBox = ({ isOpen, setIsOpen }) => {
  const { t } = useTranslation();
  const close = () => setIsOpen(0);

  const contactRow = (href, icon, label, external) => (
    <a
      href={href}
      rel="noopener noreferrer"
      target={external ? "_blank" : undefined}
      className="w-full flex items-center gap-6 border-0 border-b border-solid border-[--primary] pb-2 text-[--gr-9] hover:text-[--primary]"
    >
      <span className="text-[--primary] text-3xl w-10 flex justify-center">
        {icon}
      </span>
      <span>{label}</span>
    </a>
  );

  return (
    <>
      <Modal
        open={isOpen === 1}
        onClose={close}
        title={t("nav.li3")}
        maxWidth="max-w-[45rem]"
      >
        <p className="text-[--gr-5]">{t("nav.info1.txt1")}</p>
        <p className="text-[--gr-5] mt-2">{t("nav.info1.txt2")}</p>
        <p className="text-[--primary] mt-3">
          <a
            href="https://youtu.be/J8X1Ayj1qa4?si=4e7SfVNK2WeDTV0m"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("nav.info1.txt3")}
          </a>
        </p>
      </Modal>

      <Modal
        open={isOpen === 2}
        onClose={close}
        title={t("nav.li2")}
        maxWidth="max-w-[35rem]"
      >
        <div className="w-full flex flex-col items-center">
          <div className="w-full max-w-[22rem] flex flex-col gap-3">
            {contactRow(
              "tel:+908508407807",
              <BsTelephoneFill aria-hidden="true" />,
              t("nav.callUs")
            )}
            {contactRow(
              "https://wa.me/908508407807",
              <FaWhatsapp aria-hidden="true" />,
              "WhatsApp",
              true
            )}
            {contactRow(
              "mailto:support@liwasoft.com",
              <TfiEmail aria-hidden="true" />,
              "support@liwasoft.com"
            )}
            {contactRow(
              "http://forum.liwasoft.com/",
              <MdForum aria-hidden="true" />,
              "forum.liwasoft.com",
              true
            )}
            {contactRow(
              "https://www.youtube.com/@liwasoft/videos",
              <TbBrandYoutube aria-hidden="true" />,
              "YouTube",
              true
            )}
            {contactRow(
              "https://www.instagram.com/liwasoft/",
              <LuInstagram aria-hidden="true" />,
              "Instagram",
              true
            )}
            <div className="w-full text-center mt-2 text-sm font-light text-[--primary]">
              <a
                href="https://liwasoft.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                liwasoft.com
              </a>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        open={isOpen === 3}
        onClose={close}
        title={t("nav.li1")}
        maxWidth="max-w-[35rem]"
      >
        <div className="text-[--gr-5] text-center">
          <p>{t("nav.info1.txt2")}</p>
          <p className="mt-4">
            <a
              href="https://liwasoft.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-5 py-2.5 rounded-lg bg-[--primary] text-white hover:bg-[--primary-hover]"
            >
              liwasoft.com
            </a>
          </p>
        </div>
      </Modal>
    </>
  );
};

export default LoginNav;
